<template>
  <v-container fluid>
    <v-card class="elevation-10">
      <v-skeleton-loader
        :loading="loading"
        type="table"
      >
        <v-card-actions>
          <v-row>
            <v-col
              cols="4"
              md="3"
              xl="4"
            >
              <v-toolbar
                flat
              >
                <v-toolbar-title class="md-4 white--text">
                  Payment Channel Type
                </v-toolbar-title>
              </v-toolbar>
            </v-col>
            <v-col
              cols="4"
              md="3"
              xl="4"
            >
              <v-text-field
                v-model="search"
                placeholder="Search"
                append-icon="fa fa-search"
                label="Search Payment Channel Type"
                hide-no-data
                hide-selected
                clearable
              />
            </v-col>
            <v-col
              cols="1"
              md="3"
              xl="1"
            />
            <v-col
              cols="3"
              md="3"
              xl="3"
              class="mt-2 text-right"
            >
              <payment-channel-type-dialog-create
                @created="loadData"
              />
            </v-col>
          </v-row>
        </v-card-actions>

        <v-data-table
          dense
          :headers="headers"
          :items="paymentChannelTypes"
          :items-per-page="17"
          multi-sort
          class="scrollable-table elevation-10"
          :search="search"
        >
          <template v-slot:[`item.company`]="{ item }">
            <div>
              <span>
                {{ item.name }}
              </span>
            </div>
          </template>

          <template v-slot:[`item.action`]="{ item }">
            <payment-channel-type-dialog-edit
              :payment-channel-type="item"
              @updated="loadData"
            />
            <span class="mx-1" />
            <payment-channel-type-dialog-delete
              :payment-channel-type="item"
              @deleted="loadData"
            />
          </template>
        </v-data-table>
      </v-skeleton-loader>
    </v-card>
  </v-container>
</template>

<script>
  export default {
    data () {
      return {
        loading: true,
        dialog: false,
        snack: '',
        snackColor: '',
        snackText: '',
        search: '',

        paymentChannelTypes: [],

        headers: [
          { text: 'Name', value: 'name' },
          { text: 'Action', value: 'action', align: 'center', class: 'md-2', sortable: false },
        ],
      }
    },

    created () {
      this.loadData()
    },

    methods: {
      loadData () {
        this.$api.paymentChannelTypes().list()
          .then(response => {
            this.paymentChannelTypes = response.data
            this.loading = false
          }).catch(err => {
            console.log(err)
          })
      },
    },
  }
</script>

<style scoped>
    .center-snackbar .v-snack__wrapper .v-snack__content{
        margin:auto !important;
        width:unset !important;
    }
</style>
